export default __webpack_public_path__ + "static/media/HeroSVG2.4f9115e0.png";